/**
 * Times as people say them.
 *
 * The schedule stores twenty-four hour times because that sorts and compares cleanly. Nobody
 * reads them that way, so every time shown to a person goes through here first.
 */
export function twelveHour(value: string): string {
  const [hourText = "0", minute = "00"] = value.split(":");
  const hour = Number(hourText);
  if (!Number.isFinite(hour)) return value;
  return `${hour % 12 || 12}:${minute} ${hour >= 12 ? "p.m." : "a.m."}`;
}
